import React, { useEffect, useState } from "react";
import AdminHeading from "../Heading/AdminHeading";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import "../../PagesStyles/AdminMasters.css";
import { TbCircleNumber1 } from "react-icons/tb";
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a18,
  a227,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
} from "../../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../../Other Functions/AlertMessage";
import { allDevicesList } from "../../../Api/AllDevicesList";

export default function AdminAddDevices() {
  const [active, setActive] = useState("List");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    DeviceType: "",
    DeviceCode: "",
    DeviceActivationDate: "",
    DeviceDeactivationDate: "",
    DeviceStatus: "",
    DeviceSerialNo: "",
    DeviceBuildNo: "",
    DeviceModel: "",
    MobileNo: "",
    ClientCode: "",

    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a227, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);
  console.log(allCategories, "allCategories");
  console.log(allCompaniesList, "allCompaniesList");
  console.log(allDepartmentsList, "allDepartmentsList");
  console.log(allBranchesList, "allBranchesList");
  console.log(allRolesList, "allRolesList");

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
  };
  console.log(newCategory, "newCategory");
  console.log(newCategory, "newCategory");

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      DeviceType: newCategory.DeviceType,
      DeviceCode: newCategory.DeviceCode,
      DeviceActivationDate: newCategory.DeviceActivationDate,
      DeviceDeactivationDate: newCategory.DeviceDeactivationDate,
      DeviceStatus: newCategory.DeviceStatus,
      DeviceSerialNo: newCategory.DeviceSerialNo,
      DeviceBuildNo: newCategory.DeviceBuildNo,
      DeviceModel: newCategory.DeviceModel,
      MobileNo: newCategory.MobileNo,

      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, "formData to send");
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a112 : a111,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        DeviceType: "",
        DeviceCode: "",
        DeviceActivationDate: "",
        DeviceDeactivationDate: "",
        DeviceStatus: "",
        DeviceSerialNo: "",
        DeviceBuildNo: "",
        DeviceModel: "",
        MobileNo: "",
        ClientCode: "",
        OldEntry: false,
      });
      if (data.message) {
        // alert(data.message);
        setMessageType("error");
        setMessageToShow(data.message);
        setShowError(true);
        setActive("AddNew");
      } else {
        setMessageType("success");
        setMessageToShow("Category Added Successfully");
        setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, "data");
    console.log(data, "data");
    console.log(data, "data");
    setNewCategory({ ...data, OldEntry: true });
    setActive("AddNew");
  };
  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Devices"}
          companyName={"Loyalstring"}
          module={"User Masters"}
          page={"Devices"}
        />
        <div className="adminAddCategoryMainBox">
          <div className="adminAddCategoryInnerBox">
            <div className="adminAddCategoryInnerBoxTitlesBox">
              <div
                onClick={() => {
                  setActive("List");
                }}
                className={
                  active === "List"
                    ? "adminAddCategoryInnerBoxTitle"
                    : "adminAddCategoryInnerBoxTitle activeCategoryTitle"
                }
              >
                <div
                  className={
                    active === "List"
                      ? "adminAddCategoryInnerBoxTitleLogo"
                      : "adminAddCategoryInnerBoxTitleLogo activeCategoryLogo"
                  }
                >
                  {/* 01 */}
                  <RiListUnordered />
                </div>
                <p>All Devices</p>
              </div>

              <div
                id="addCategoryListTitle"
                onClick={() => setActive("AddNew")}
                className={
                  active === "AddNew"
                    ? "adminAddCategoryInnerBoxTitle"
                    : "adminAddCategoryInnerBoxTitle activeCategoryTitle"
                }
              >
                <div
                  id="addCategoryListLogo"
                  className={
                    active === "AddNew"
                      ? "adminAddCategoryInnerBoxTitleLogo"
                      : "adminAddCategoryInnerBoxTitleLogo activeCategoryLogo"
                  }
                >
                  {/* 02 */}
                  <RiPlayListAddLine />
                </div>
                <p>Add Devices</p>
              </div>
            </div>
            <div
              className={
                active === "List" ? "adminCategoryListMainBox" : "none"
              }
            >
              <table>
                <thead>
                  <tr>
                    <th>Edit</th>
                    <th>Sr.No</th>
                    <th>Device Type</th>
                    <th>Device Code</th>
                    <th>Device Activation Date</th>
                    <th>Device Deactivation Date</th>
                    <th>Device Status</th>
                    <th>Device Serial No</th>
                    <th>Device Build No</th>
                    <th>Device Model</th>
                    <th>Mobile No</th>
                  </tr>
                </thead>
                <tbody>
                  {allCategories.map((x, index) => (
                    <tr key={x.id}>
                      <td>
                        <button
                          className="adminAddCategoryEditButton"
                          // onClick={() => handleEditClick(x.id)}
                          onClick={() => handleEditData(x)}
                        >
                          Edit
                        </button>
                      </td>
                      <td>{index + 1}</td>
                      {/* <td>{x.CompCode}</td>
                      <td>{x.BranchCode}</td> */}
                      <td>{x.DeviceType}</td>
                      <td>{x.DeviceCode}</td>
                      <td>{x.DeviceActivationDate}</td>
                      <td>{x.DeviceDeactivationDate}</td>
                      <td>{x.DeviceStatus}</td>
                      <td>{x.DeviceSerialNo}</td>
                      <td>{x.DeviceBuildNo}</td>
                      <td>{x.DeviceModel}</td>
                      <td>{x.MobileNo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div
              className={
                active !== "List" ? "adminCategoryAddCategoryMainBox" : "none"
              }
            >
              <p>Add New Device</p>
              <form onSubmit={addNewCategory}>
                <div
                  style={{
                    gridTemplateColumns: "repeat(4,1fr)",
                    columnGap: "40px",
                  }}
                  className="adminCategoryAddCategoryInnerBox"
                >
                  <label>Device Code</label>
                  <input
                    style={{ cursor: "not-allowed" }}
                    name="DeviceCode"
                    value={newCategory.DeviceCode}
                    readOnly
                  />
                  <label>
                    Device Type <sup>*</sup>
                  </label>
                  <select
                    name="DeviceType"
                    value={newCategory.DeviceType}
                    onChange={handleNewCategoryChange}
                    type="text"
                    required="required"
                  >
                    <option value={""}>Select an option</option>;
                    {allDevicesList.map((x) => {
                      return (
                        <>
                          <option value={x}>{x}</option>;
                        </>
                      );
                    })}
                  </select>
                  <label>
                    Device Activation Date <sup>*</sup>
                  </label>
                  <input
                    name="DeviceActivationDate"
                    value={newCategory.DeviceActivationDate}
                    onChange={handleNewCategoryChange}
                    type="date"
                    required="required"
                  />
                  <label>
                    Device Deactivation Date <sup>*</sup>
                  </label>
                  <input
                    name="DeviceDeactivationDate"
                    value={newCategory.DeviceDeactivationDate}
                    onChange={handleNewCategoryChange}
                    type="date"
                    required="required"
                  />
                  <label>Device Serial No</label>
                  <input
                    name="DeviceSerialNo"
                    value={newCategory.DeviceSerialNo}
                    onChange={handleNewCategoryChange}
                    type="text"
                    // required="required"
                  />
                  <label>Device Build No</label>
                  <input
                    name="DeviceBuildNo"
                    value={newCategory.DeviceBuildNo}
                    onChange={handleNewCategoryChange}
                    type="text"
                    // required="required"
                  />
                  <label>Device Model</label>
                  <input
                    name="DeviceModel"
                    value={newCategory.DeviceModel}
                    onChange={handleNewCategoryChange}
                    type="text"
                    // required="required"
                  />
                  <label>Mobile No</label>
                  <input
                    name="MobileNo"
                    value={newCategory.MobileNo}
                    onChange={handleNewCategoryChange}
                    type="text"
                    // required="required"
                  />
                  <label>Device Status</label>
                  <input
                    style={{ cursor: "not-allowed" }}
                    name="DeviceStatus"
                    value={newCategory.DeviceStatus}
                    readOnly
                  />
                </div>
                {!loading ? <button type="submit">Submit</button> : null}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
